// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontFamily, fontSize } from '../../Design_System/DesignSystem';

// COMPONENT
import { Text } from '../atoms/Text';
import picture from '../../assets/picture.png';
import { useLanguage } from '../../i18n/LanguageContext';
import { parseBold } from '../../i18n/parseBold';

const Home = () => {
  const { t } = useLanguage();
  return (
    <HomeContainer>
      <CustomImg>
        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
        <img src={picture} alt="Picture of Tristan Lemire" />
      </CustomImg>
      <Conainer>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={false}
        >
          {parseBold(t.home.p1)}
        </Text>
        <br />
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={false}
        >
          {parseBold(t.home.p2)}
        </Text>
        <br />
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={false}
        >
          {parseBold(t.home.p3)}
        </Text>
      </Conainer>
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

const Conainer = styled.div`
  max-width: 300px;
  margin: 20px;
  height: 100%
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: end;
`;

const CustomImg = styled.div`
  width: 300px;
  margin: 20px;
  @media ((max-height: 690px) and (min-width: 845px)) or (max-width: 429px) {
    display: none;
  }
`;

export default Home;
